import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { ClientsService } from "../../services/clients.service";
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";

import { Clients } from "../../models/clients";
import { Category } from "../../models/category";
import { UntypedFormControl } from "@angular/forms";
import { CategoryService } from "../../services/categories.service";
import { ConfirmationService, MessageService, SelectItem, PrimeTemplate } from "primeng/api";
import * as moment from "moment";
import {
  FISCAL_CODE_VALIDATOR_REGEX,
  SEX_LIST,
  STATE_LIST,
  BUSINESS_STATE_LIST,
} from "../../constants/constants";
import { ComuniService } from "src/app/services/comuni.service";
import { Comuni } from "src/app/models/comuni";
import { Location, formatDate, DatePipe } from "@angular/common";
import { BookingsService } from "src/app/services/bookings.service";
import { Bookings } from "src/app/models/bookings";
import { BillingsService } from "src/app/services/billings.service";
import { Billings } from "src/app/models/billings";
import { PersonalDataService } from "src/app/services/personal_data.service";
import { Personal_data } from "src/app/models/personal_data";
import { NgxSpinnerService } from "ngx-spinner";
import { ProvinceService } from "src/app/services/province.service";
import { RegionsService } from "src/app/services/region.service";
import { TopNavComponent } from "../../top-nav/top-nav.component";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Card } from "primeng/card";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Ripple } from "primeng/ripple";
import { SelectButton } from "primeng/selectbutton";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { InputMask } from "primeng/inputmask";
import { Textarea } from "primeng/textarea";
import { Message } from "primeng/message";
import { Timeline } from "primeng/timeline";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../../i18n/t.pipe";
import { PhoneInputComponent } from "../../components/phone-input/phone-input.component";
@Component({
    standalone: true,
    selector: "app-requests-form",
    templateUrl: "./requests-form.component.html",
    imports: [PhoneInputComponent, TPipe, TopNavComponent, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Card, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, SelectButton, InputText, Select, PrimeTemplate, InputMask, Textarea, Message, Timeline, ConfirmDialog, Toast, DatePipe, TranslatePipe]
})
export class RequestsFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private clientsService = inject(ClientsService);
  private messageService = inject(MessageService);
  private personalDataService = inject(PersonalDataService);
  private comuniService = inject(ComuniService);
  private _location = inject(Location);
  private bookingsService = inject(BookingsService);
  private billingsService = inject(BillingsService);
  private spinner = inject(NgxSpinnerService);
  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  readonly imagePath = signal<any>(undefined);
  clients: Clients;
  client: Clients;

  clientsList: any = [];

  categories: any = [];
  category: Category;
  checked: boolean = true;
  selectedValue: string;
  readonly comuni = signal<Comuni[]>([]);
  readonly comuniCategory = signal<Comuni[]>([]);
  blogForm: UntypedFormGroup;
  readonly typeList = signal<any[]>(undefined);

  cities: Clients[];
  format1: string = "";
  format2: string = "";
  selectedCity: Clients;
  selectedCategories: Category;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  readonly bookings = signal<any>([]);
  is_featured = "0";
  readonly deleteButton = signal<boolean>(undefined);
  readonly billings = signal<any>([]);
  billing: Billings;
  readonly currentUser = signal<any>(undefined);
  addForm: UntypedFormGroup;
  rows: UntypedFormArray;
  itemForm: UntypedFormGroup;
  skillsForm: UntypedFormGroup;
  readonly skillsValues = signal<any>([]);
  readonly stateOptions = signal<any[]>(undefined);
  cols: any[];
  exportColumns: any[];
  _selectedColumns: any[];
  readonly businessStateOptions = signal<any[]>(undefined);
  readonly personal_datas = signal<any>([]);
  personal_data: Personal_data;
  readonly personName = signal<string>(undefined);

  trackByFn(index, item) {
    return item.id;
  }

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }
    this.currentUser.set(JSON.parse(localStorage.getItem("currentUser") || "[]"));
    this.typeList.set(SEX_LIST);
    this.stateOptions.set(STATE_LIST);
    this.businessStateOptions.set(BUSINESS_STATE_LIST);
  }

  ngOnInit() {

    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.pageTitle.set("Modifica Cliente");
      this.deleteButton.set(true);

      this.clientsService.getId(id).subscribe((res) => {
        this.loadComuniCategory(res.category_id);
        this.loadComuni(res.province);

        this.blogForm.patchValue({
          name: res.name,
          surname: res.surname,
          username: res.name + " " + res.surname,
          city: res.city,
          zip: res.zip,
          address: res.address,
          province: res.province,
          region: res.region,
          email: res.email,
          phone: res.phone,
          fiscalcode: res.fiscalcode,
          fiscalnumber: res.fiscalnumber,
          description: res.description,
          user_id: this.currentUser().user_id,
          category_id: res.category_id,
          is_featured: res.is_featured,
          is_active: res.is_active,
          date: res.date,
          id: res.id,
          skills: this.skillsValues(),
        });

        this.imagePath.set(res.image);
        this.personName.set(res.name + " " + res.surname);
      });

      const params = {
        page: 0,
        size: 10,
        category_id: id,
      };
      this.billingsService.list(params).subscribe((pData) => {
        this.billings.set(pData);
      });
    } else {
      this.deleteButton.set(false);
      this.pageTitle.set("Aggiungi Cliente");
    }

    this.blogForm = this.fb.group({
      id: [""],
      name: ["", Validators.required],
      surname: ["", Validators.required],
      username: [""],
      city: ["", Validators.required],
      zip: ["", Validators.required],
      address: ["", Validators.required],
      province: ["", Validators.required],
      region: [""],
      email: ["", Validators.required],
      phone: ["", Validators.required],
      fiscalcode: new UntypedFormControl("", Validators.compose([codFisc])),
      fiscalnumber: new UntypedFormControl(""),
      description: [""],
      is_featured: ["0"],
      user_id: [this.currentUser().user_id],
      category_id: ["", Validators.required],
      is_active: ["0"],
      image: [""],
      date: ["", Validators.required],
      skills: this.initSkill(),
    });

    this.loadBookings(id);
    this.loadPersonalData();

  }

  onSearch(event: any) {
    const query = event.filter;

    if (query && query.length >= 3) {
      this.searchComuni(query);
    }
  }

  onSearchCategory(event: any) {
    const query = event.filter;

    if (query && query.length >= 3) {
      this.searchComuniCategory(query);
    }
  }

  searchComuniCategory(query: string) {
    const paramsSearchComuni = {
      name: query,
    };

    this.comuniService.list(paramsSearchComuni).subscribe((pData) => {
      this.comuniCategory.set(pData);
    });
  }

  searchComuni(query: string) {
    const paramsSearchComuni = {
      name: query,
    };

    this.comuniService.list(paramsSearchComuni).subscribe((pData) => {
      this.comuni.set(pData);
    });
  }

  loadComuniCategory(query: string) {
    const paramsComuni = {
      id: query,
      page: 0,
      size: 10,
    };

    this.comuniService.list(paramsComuni).subscribe((pData) => {
      this.comuniCategory.set(pData);
      (error) => (this.error.set(error));
    });
  }

  loadComuni(query: string) {
    const paramsComuni = {
      id: query,
      page: 0,
      size: 10,
    };

    this.comuniService.list(paramsComuni).subscribe((pData) => {
      this.comuni.set(pData);
      (error) => (this.error.set(error));
    });
  }
  loadPersonalData() {
    const paramsPersonalData = [];
    this.personalDataService.list(paramsPersonalData).subscribe((pData) => {
      this.personal_datas.set(pData);
      (error) => (this.error.set(error));
    });
  }

  loadBookings(id: string) {
    const params = {
      page: 0,
      size: 100,
      category_id: id,
    };
    this.bookingsService.list(params).subscribe((pData) => {
      this.bookings.set(pData);
    });
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath.set(reader.result);
      };
    }
  }

  removeQuantity(i: number) {
    this.skills.removeAt(i);
  }

  getCategoryItem(category_id: string, id: string) {
    return this.categories.find((item) => item.id === category_id);
  }

  hasNoSelectedBookings() {
    return (
      this.bookings().filter((booking) => booking.title).length === 0
    );
  }

  hasNoSelectedBillings() {
    return this.billings().filter((billing) => billing.title).length === 0;
  }

  onDelete(id: string, title: string) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.clientsService.delete(id).subscribe(
          (res) => {
            console.log(res);
            this.messageService.add({
              key: "cancel",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
            this._location.back();
          },
          (error) => {
            this.error.set(error);
            this.messageService.add({
              key: "cancel",
              severity: "warn",
              summary: "Attenzione",
              detail: "Errore backend",
            });
          }
        );
      },
    });
  }

  initSkill() {
    var formArray = this.fb.array([]);
    const id = this.route.snapshot.paramMap.get("id");

    const findParam = {
      field: "skills",
    };

    this.clientsService.find(id, findParam).subscribe((res) => {
      this.skillsValues.set(res);

      this.skillsValues().forEach((e) => {
        formArray.push(
          this.fb.group({
            qty: [e.qty],
            price: [e.price],
          })
        );
      });
    });

    return formArray;
  }

  private createSkillFormGroup(skill: any): UntypedFormGroup {
    return new UntypedFormGroup({
      qty: new UntypedFormControl(skill.qty),
      price: new UntypedFormControl(skill.price),
    });
  }

  public addSkill(skill: any) {
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.blogForm.get("skills") as UntypedFormArray;
  }

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      qty: "",
      price: "",
    });
  }

  addQuantity() {
    this.skills.push(this.newQuantity());
  }

  removeImageFile() {
    this.imagePath.set("");
    const myInputVariable = this.myInputVariable();
    console.log(myInputVariable.nativeElement.files);
    myInputVariable.nativeElement.value = "";
    console.log(myInputVariable.nativeElement.files);
  }

  get title() {
    return this.blogForm.get("title");
  }

  get id() {
    return this.blogForm.get("id").value;
  }

  get description() {
    return this.blogForm.get("description");
  }

  onSubmit() {
    const formData = new FormData();
    formData.append("name", this.blogForm.get("name").value);
    formData.append("surname", this.blogForm.get("surname").value);
    formData.append("username", this.blogForm.get("username").value);
    formData.append("city", this.blogForm.get("city").value);
    formData.append("zip", this.blogForm.get("zip").value);
    formData.append("address", this.blogForm.get("address").value);
    formData.append("province", this.blogForm.get("province").value);
    formData.append("email", this.blogForm.get("email").value);
    formData.append("phone", this.blogForm.get("phone").value);
    formData.append("fiscalcode", this.blogForm.get("fiscalcode").value);
    formData.append("fiscalnumber", this.blogForm.get("fiscalnumber").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("is_featured", this.blogForm.get("is_featured").value);
    formData.append("category_id", this.blogForm.get("category_id").value);
    formData.append("user_id", this.blogForm.get("user_id").value);
    formData.append("is_active", this.blogForm.get("is_active").value);
    formData.append("image", this.blogForm.get("image").value);
    formData.append("date", this.blogForm.get("date").value);
    formData.append(
      "skills",
      JSON.stringify(this.blogForm.get("skills").value)
    );

    const id = this.blogForm.get("id").value;

    if (id) {
      this.clientsService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });

          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      this.clientsService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });
            this.router.navigate(["/admin/clients"]);
          }
        },
        (error) => (this.error.set(error))
      );
    }
  }
}

export function codFisc(c: UntypedFormControl): { [s: string]: boolean } {
  if (c.value && !c.value.match(FISCAL_CODE_VALIDATOR_REGEX)) {
    return { invalidCF: true };
  }
}
